import { render, staticRenderFns } from "./StepDocumentation.vue?vue&type=template&id=71173dde"
import script from "./StepDocumentation.vue?vue&type=script&lang=js"
export * from "./StepDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports